import { useMemo } from "react";

import { defineMessage, useIntl } from "react-intl";

import { MobileNavCardProps } from "./mobile-nav-card";
import { MobileNavMenuPage } from "./mobile-nav-menu-page";

export const MobileNavWhyAtlassian = () => {
    const intl = useIntl();

    function useWhyAtlassianData(): Array<MobileNavCardProps> {
        return useMemo(() => {
            return [
                {
                    key: "integrations",
                    href: "/government",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.integrations.title",
                            defaultMessage: "Integrations"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.integrations.content",
                            defaultMessage:
                                "Connect thousands of apps to your Atlassian products"
                        })
                    )
                },
                {
                    key: "customers",
                    href: "/customers",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.customers.title",
                            defaultMessage: "Customers"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.customers.content",
                            defaultMessage:
                                "Case studies & stories powered by teamwork"
                        })
                    )
                },
                {
                    key: "fedramp",
                    href: "#",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.fedramp.title",
                            defaultMessage: "FEDRamp"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.fedramp.content",
                            defaultMessage:
                                "Compliant solutions for the public sector"
                        })
                    )
                },
                {
                    key: "resilience",
                    href: "/trust/resilience",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.resilience.title",
                            defaultMessage: "Resilience"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.resilience.content",
                            defaultMessage:
                                "Enterprise-grade & highly performant infrastructure"
                        })
                    )
                },
                {
                    key: "platform",
                    href: "/platform",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.platform.title",
                            defaultMessage: "Platform"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.platform.content",
                            defaultMessage:
                                "Our deeply integrated, reliable & secure platform"
                        })
                    )
                },
                {
                    key: "trust-center",
                    href: "/trust",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.trustcenter.title",
                            defaultMessage: "Trust center"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.whyatlassian.trustcenter.content",
                            defaultMessage:
                                "Ensure your data’s security, compliance & availability"
                        })
                    )
                }
            ];
        }, []);
    }

    const whyAtlassianData = useWhyAtlassianData();

    return (
        <MobileNavMenuPage
            pageLabel={intl.formatMessage({
                id: "globalnav.v2.whyatlassian.title",
                defaultMessage: "Why Atlassian"
            })}
            cards={whyAtlassianData}
        />
    );
};
